import BigQuery from "../../../../contents/docs/cdp/sources/_snippets/source-bigquery.mdx";
import * as React from 'react';
export default {
  BigQuery,
  React
};